import '@front10/landing-page-book/dist/themes/default/index.css';

import React, { useEffect, useState } from 'react';

import { BrowserRouter as Router, Route } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';

import 'font-awesome/css/font-awesome.min.css';

import './App.css';

import { ScrollToTop } from './components/ScrollToTop';
import { getUser } from './services/loginService';
import { PricingPage } from './components/pages/PricingPage/PricingPage';
import { initOrtto, setAnalyticsUserData, trackAmplitudeEvent } from './utils/analytics';
import { SubscriptionService } from './services/SubscriptionService';
import { useCheckUrl } from './common/hooks/useCheckUrl';
import { IframeModeService } from 'services/iframeModeService';

IframeModeService.init();

const ALLOW_FETCH = navigator.userAgent !== 'ReactSnap';

const App = React.memo(() => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    async function fetchData() {
      try {
        const response = await getUser();

        if (response.ok) {
          const userData = await response.json();

          if (userData.subscription) {
            setUser(userData);
            setAnalyticsUserData(userData);
            SubscriptionService.SetUser(userData);
            initOrtto(userData);
          }
        }
      } catch (e) {
        console.error(e);
      }

      setLoading(false);
    }

    if (!user) {
      trackAmplitudeEvent('#Homepage Visitor');
    }
    // Disable fetch from react-snap rendering
    if (ALLOW_FETCH) fetchData();
  }, []);

  useCheckUrl();

  return (
    <Router>
      <ScrollToTop>
        <Route
          key="pricing"
          exact
          path="/packages_module"
          render={() => <PricingPage user={user} loading={loading} />}
        />
      </ScrollToTop>
    </Router>
  );
});

export default App;
